import { logApi } from 'api';
import { GoogleIcon, MetaIcon } from 'components';
import GenericModal from './GenericModal';
import { useGoogleAds } from 'hooks/useGoogleAds';
import { useMetaAds } from 'hooks/useMetaAds';
import { useAuth } from 'components/context/AuthContext';


const { createLog } = logApi;

const NoAdsConnectedModal = ({
  isOpen,
  onClose,
  title = '',
  description = '',
}) => {
  const { hasGoogleAdsConnected, hasMetaConnected } = useAuth();
  const { connectGoogleAds } = useGoogleAds();
  const { startMetaOAuth } = useMetaAds();

  const handleMetaAdsConnect = () => {
    createLog({
      level: 'info',
      message: 'Click en "Conectar Meta Ads" en modal de NoAdsConnectedModal'
    });
    startMetaOAuth(false);
  };

  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      toggle={onClose}
      title={title}
      description={description}
      closable={true}
    >
      <div className="flex flex-col gap-4 w-full">
        {!hasGoogleAdsConnected && (
          <button
            onClick={() => connectGoogleAds(false)}
            className="w-full px-5 py-3 bg-white text-primary rounded-lg hover:text-white hover:bg-primary-dark bg-opacity-90 transition-colors font-medium shadow-md"
          >
            <div className="flex items-center justify-center gap-2">
              <GoogleIcon width={24} height={24} />
              Conectar Google Ads
            </div>
          </button>
        )}
        
        {!hasMetaConnected && (
          <button
            onClick={handleMetaAdsConnect}
            className="w-full px-5 py-3 bg-white text-primary rounded-lg hover:text-white hover:bg-primary-dark bg-opacity-90 transition-colors font-medium shadow-md"
          >
            <div className="flex items-center justify-center gap-2">
              <MetaIcon width={24} height={24} />
              Conectar Meta Ads
            </div>
          </button>
        )}
      </div>
    </GenericModal>
  );
};

export default NoAdsConnectedModal;
